import { send } from 'server';
import { TBonusTriggerResponse } from 'js/hooks/socket/types';

export const submitPromoCode = (promoCode: string): Promise<TBonusTriggerResponse> => send({
    ID: 31065,
    description: 'Apply promo code',
    responses: [31066, 31067],
    promotionCode: promoCode,
    triggerType: 'PromotionCode'
});
